import { useTranslation } from 'utils/i18n';
import { SMALL_TABLET_WIDTH } from '../../constants/breakpoints';
import useIsMobile from '../../hooks/useIsMobile';
import IconWithHyperlink from '../iconWithHyperlink';

interface Organisation {
  name: string;
  largeIcon?: string;
  url?: string;
}

interface Props {
  name: string;
  fullAddress: string;
  organisation: Organisation;
}

const VenueHeader = ({ name, fullAddress, organisation }: Props) => {
  const { t } = useTranslation('common');
  const isMobileView = useIsMobile(SMALL_TABLET_WIDTH);

  const renderManagedByText = <span>{t('shared.managed_by')}:&nbsp;</span>;

  const desktopView = () => {
    return (
      <h4>
        {renderManagedByText}
        {`${organisation.name}`}
      </h4>
    );
  };

  const mobileView = () => {
    return (
      <>
        {renderManagedByText}
        <h4>{`${organisation.name}`}</h4>
      </>
    );
  };

  return (
    <div className="venue__header">
      <div className="venue__details">
        <div className="venue__heading">
          <h1>{name}</h1>
        </div>
        <div className="venue__address">
          <h4>{fullAddress}</h4>
        </div>
      </div>

      <div className="venue__organisation">
        <div className="venue__organisation-icon">
          <IconWithHyperlink
            name={organisation.name}
            icon={organisation.largeIcon ?? ''}
            url={organisation.url ?? ''}
          />
        </div>
        <div className="venue__organisation-name">
          {isMobileView ? mobileView() : desktopView()}
        </div>
      </div>
    </div>
  );
};
export default VenueHeader;
